import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Only initialize in browser (not during SSR/webpack build)
if (typeof window !== 'undefined') {
  i18n
    // Load translations from public folder
    .use(HttpBackend)
    // Detect user language
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next
    .use(initReactI18next)
    // Initialize i18next
    .init({
      fallbackLng: 'en',
      debug: process.env.NODE_ENV === 'development',
      
      // Supported languages
      supportedLngs: ['en', 'es-MX', 'es-ES'],
      
      // Language detection options
      detection: {
        order: ['localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng',
      },
      
      // Backend options for loading translation files
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
      
      // Namespace options
      ns: ['common', 'marketing', 'dashboard', 'forms', 'errors'],
      defaultNS: 'common',
      
      interpolation: {
        escapeValue: false, // React already escapes values
      },
      
      react: {
        useSuspense: true, // Enable suspense for async loading
      },
    });
}

export default i18n;
